import { parse, format } from "date-fns";

export const formatDate = (dateString) => {
  if (!dateString) return "";
  return format(parse(dateString, "dd-MM-yyyy", new Date()), "dd/MM/yyyy");
};


export const formatCalenderDate = (date) => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
export const removeEmptyKeys = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      if (Array.isArray(value)) return value.length > 0; // keep only non-empty arrays
      return value !== null && value !== "" && value !== undefined;
    })
  );
};


export const replaceEmptyWithNull = (obj) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, value === "" ? null : value])
  );

export const cleanCodes = (codes) => codes.filter(Boolean);

export const calculateLOS = (admissionDate, separationDate) => {
  if (!admissionDate || !separationDate) return "";

  const diffDays = Math.round(
    (separationDate - admissionDate) / (1000 * 60 * 60 * 24)
  );

  return diffDays === 0 ? 1 : diffDays;
};

const toDate = (value) => {
  if (value instanceof Date) return value;
  if (typeof value === "string") {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(Date.UTC(year, month - 1, day));
  }
  return null; // fallback for invalid input
};

export const calculateAge = (dob, admissionDate) => {
  if (!dob || !admissionDate) {
    // console.error("Missing date input:", { dob, admissionDate });
    return { ageyears: null, agedays: 0 };
  }

  const birthDate = toDate(dob);
  const admitDate = toDate(admissionDate);

  if (!birthDate || !admitDate || isNaN(birthDate) || isNaN(admitDate)) {
    // console.error("Invalid date format.");
    return { ageyears: null, agedays: 0 };
  }

  let ageYears = admitDate.getUTCFullYear() - birthDate.getUTCFullYear();

  if (
    admitDate.getUTCMonth() < birthDate.getUTCMonth() ||
    (admitDate.getUTCMonth() === birthDate.getUTCMonth() && admitDate.getUTCDate() < birthDate.getUTCDate())
  ) {
    ageYears--;
  }

  let ageDays = 0;
  if (ageYears < 1) {
    const diffTime = admitDate - birthDate;
    ageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }

  return ageYears < 1
    ? { ageyears: null, agedays: ageDays }
    : { ageyears: ageYears, agedays: 0 };
};


export const getLocalStorageItem = (key, defaultValue = null) => {
    const item = sessionStorage.getItem(key);
    return item !== null ? JSON.parse(item) : defaultValue;
  };
  
export const setLocalStorageItem = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
};
export const getErrorMessage = (errorMessage, type, searchBy) => {
  if (errorMessage[type]) {
    return "";
  }

  if (searchBy === "Code") {
    return "Please search by code only...";
  } else if (searchBy === "Description") {
    return "Please search by description only...";
  }

  // Default fallback
  return "Type code or drag and drop from Codebook";
};

export const formatWeightValue = (weightValue) => 
    weightValue === "can't determine" ? "-" : weightValue;
  
  export const formatReimbursement = (weightValue) => 
    weightValue === "can't determine" ? "-" : `$${Math.round(weightValue * 6465)}`;
  
  
  